import {useCallback, useState, type MouseEvent} from 'react';

const MAX_DEGREES = 5;

function buildTransform(rotateX: number, rotateY: number): string {
    return `rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`;
}

function prefersReducedMotion(): boolean {
    return typeof window !== 'undefined'
        && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}

export function useCardTilt() {
    const [isHovered, setIsHovered] = useState(false);
    const [tilt, setTilt] = useState({rotateX: 0, rotateY: 0});

    const handleMouseEnter = useCallback(() => {
        if (prefersReducedMotion()) {
            return;
        }
        setIsHovered(true);
    }, []);

    const handleMouseMove = useCallback((event: MouseEvent<HTMLDivElement>) => {
        if (prefersReducedMotion()) {
            return;
        }
        const rect = event.currentTarget.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) {
            setTilt({rotateX: 0, rotateY: 0});
            return;
        }
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const rotateY = ((x - rect.width / 2) / (rect.width / 2)) * MAX_DEGREES;
        const rotateX = ((rect.height / 2 - y) / (rect.height / 2)) * MAX_DEGREES;

        setTilt({rotateX, rotateY});
    }, []);

    const handleMouseLeave = useCallback(() => {
        setIsHovered(false);
        setTilt({rotateX: 0, rotateY: 0});
    }, []);

    return {
        isHovered,
        containerProps: {
            onMouseEnter: handleMouseEnter,
            onMouseMove: handleMouseMove,
            onMouseLeave: handleMouseLeave,
        },
        cardStyle: {
            transform: buildTransform(tilt.rotateX, tilt.rotateY),
            transformStyle: 'preserve-3d' as const,
        },
    };
}
